import React from "react";
import { Spinner } from "reactstrap";

import EmptyState from "components/EmptyState";
import AdminFlashMessage from "components/admin/AdminFlashMessage";

export default function AdminStateBlock({
  flash,
  onDismissFlash,
  error,
  onDismissError,
  loading,
  spinnerColor = "dark",
  isEmpty,
  emptyTitle,
  emptyDescription,
  emptyIcon,
  children,
}) {
  return (
    <>
      <AdminFlashMessage flash={flash} onDismiss={onDismissFlash} />
      {error ? <AdminFlashMessage flash={{ color: "danger", message: error }} onDismiss={onDismissError} /> : null}

      {loading ? (
        <div className="text-center py-5">
          <Spinner color={spinnerColor} />
        </div>
      ) : null}

      {!loading && isEmpty ? <EmptyState title={emptyTitle} description={emptyDescription} icon={emptyIcon} /> : null}
      {!loading && !isEmpty ? children : null}
    </>
  );
}
